import {Alert, Typography} from "@material-tailwind/react";
import React from "react";

export function AgentServiceDetailFormAlert() {
  return (
    <Alert className="mb-8 w-full px-0" variant="outlined">
      <Typography variant="h5" className="mb-4">
        مشاور گرامی، لطفا به نکات زیر توجه فرمائید:
      </Typography>
      <Typography variant="body" color="blue-gray">
        <li>
          لطفا در تعیین قیمت خدمات و زمان انجام خدمات دقت لازم را بعمل آورید، زیرا هرگونه تغییر در قیمت و زمان
          ارائه خدمات امکان پذیر نیست و مشمول جریمه شما و کسر از مبلغ خدمات خواهد بود.
        </li>
        <li>
          لطفا در زمان تعیین قیمت به مواردی همچون؛ هزینه دستمزد و حق الزحمه خود، سهم پلتفرم مباشر، هزینه های دولتی
          و جانبی و مباحث ارزش افزوده و کسورات قانونی را در نظر بگیرید.
        </li>
      </Typography>
    </Alert>
  )
}
